import React from "react";
import styled from "styled-components";
import AxisCard from "./AxisCard";
import {LinearProgressBar} from "./LinearProgressBar";

const Axis = ({axis, avg}) => {

    const axisMaxSixItemForPDF = axis.length > 6 ? axis.slice(0,5) : axis
         return (
            <AxisBlock>
                <p className="enjoy-block-title">Avancement des axes</p>
                <div className="global-advancement">
                    <p>Avancement global (moyenne des axes)</p>
                    {
                        LinearProgressBar(avg)
                    }
                </div>
                <AxisList>
                    {
                        axisMaxSixItemForPDF.map(a => {
                            return <AxisCard axis={a} key={a.id}/>
                        })
                    }
                </AxisList>
            </AxisBlock>
        );
    }

    const AxisList = styled.div`
      display: grid;
      gap: 1rem;
      grid-template-columns: repeat(2, minmax(100px,45%));
      grid-template-rows: repeat(3, minmax(100px, 33%));
    `

    const AxisBlock = styled.div`
      
      .global-advancement{
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        padding: 0.5rem;
        margin-bottom: 1rem;

      }

      .global-advancement p {
        font-size: 20px;
        
        @media print{
          font-size: 15px;
        }
      }

      .advancement-div{
        display: flex;
        flex-direction: column;
        align-items: center;
        min-width: 30%
      }
      .progress-container {
        height: 0.6rem;
        width: 8rem;
        border-radius: 0.4rem;
        background: dimgrey;
        -webkit-tap-highlight-color: transparent;
        
        @media print {
          height: 0.4rem;
          width: 6rem;
        }
      }

      .advancement-div p {
        margin: 0;
        
        @media print{
          font-size: 14px; 
        }
      }
    `
export default Axis;
